(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];

  function closeMegaMenus(except, returnFocus = false) {
    let focusTarget;
    $$("[data-harrys-mega]").forEach((menu) => {
      if (menu === except) return;
      const wasOpen = menu.classList.contains("is-open");
      menu.classList.remove("is-open");
      const trigger = document.querySelector(`[aria-controls="${menu.id}"]`);
      trigger?.setAttribute("aria-expanded", "false");
      if (returnFocus && wasOpen && trigger instanceof HTMLElement) focusTarget = trigger;
    });
    focusTarget?.focus();
  }

  $$('[data-harrys-mega-trigger]').forEach((trigger) => {
    const menu = document.getElementById(trigger.getAttribute("aria-controls"));
    const item = trigger.closest("li");
    if (!menu || !item) return;
    const openMenu = () => {
      closeMegaMenus(menu);
      menu.classList.add("is-open");
      trigger.setAttribute("aria-expanded", "true");
    };
    const closeMenu = () => {
      menu.classList.remove("is-open");
      trigger.setAttribute("aria-expanded", "false");
    };
    trigger.addEventListener("click", () => {
      const open = !menu.classList.contains("is-open");
      if (open) openMenu();
      else closeMenu();
    });
    item.addEventListener("pointerenter", (event) => {
      if (event.pointerType !== "touch") openMenu();
    });
    item.addEventListener("pointerleave", (event) => {
      if (event.pointerType !== "touch" && !item.contains(document.activeElement)) closeMenu();
    });
    item.addEventListener("focusin", openMenu);
    item.addEventListener("focusout", () => {
      setTimeout(() => { if (!item.contains(document.activeElement)) closeMenu(); }, 0);
    });
  });

  const aboutMenu = $(".harrys-about-menu");
  if (aboutMenu instanceof HTMLDetailsElement) {
    const summary = $("summary", aboutMenu);
    const openAbout = () => { aboutMenu.open = true; };
    const closeAbout = () => { aboutMenu.open = false; };
    aboutMenu.addEventListener("pointerenter", (event) => {
      if (event.pointerType !== "touch") openAbout();
    });
    aboutMenu.addEventListener("pointerleave", (event) => {
      if (event.pointerType !== "touch" && !aboutMenu.contains(document.activeElement)) closeAbout();
    });
    aboutMenu.addEventListener("focusin", openAbout);
    aboutMenu.addEventListener("focusout", () => {
      setTimeout(() => { if (!aboutMenu.contains(document.activeElement)) closeAbout(); }, 0);
    });
    aboutMenu.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      closeAbout();
      summary?.focus();
    });
  }

  document.addEventListener("click", (event) => {
    if (!event.target.closest(".harrys-nav-row")) closeMegaMenus();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    closeMegaMenus(undefined, true);
    $$('dialog[open]').forEach((dialog) => dialog.close());
  });

  $$('[data-harrys-open-dialog]').forEach((button) => {
    button.addEventListener("click", () => document.getElementById(button.dataset.harrysOpenDialog)?.showModal());
  });
  $$('[data-harrys-close-dialog]').forEach((button) => {
    button.addEventListener("click", () => button.closest("dialog")?.close());
  });
  $$('dialog[data-harrys-dialog]').forEach((dialog) => {
    dialog.addEventListener("click", (event) => { if (event.target === dialog) dialog.close(); });
  });

  $$('[data-harrys-footer-toggle]').forEach((button) => {
    button.addEventListener("click", () => {
      const panel = document.getElementById(button.getAttribute("aria-controls"));
      const open = button.getAttribute("aria-expanded") !== "true";
      button.setAttribute("aria-expanded", String(open));
      panel?.classList.toggle("is-open", open);
    });
  });

  $$('[data-harrys-carousel]').forEach((carousel) => {
    const track = $("[data-harrys-track]", carousel);
    $$('[data-harrys-direction]', carousel).forEach((button) => {
      button.addEventListener("click", () => {
        const direction = button.dataset.harrysDirection === "next" ? 1 : -1;
        track?.scrollBy({ left: direction * Math.max(176, track.clientWidth * .72), behavior: "smooth" });
      });
    });
  });

  function showToast(message) {
    const toast = $("[data-harrys-toast]");
    if (!toast) return;
    $("[data-harrys-toast-message]", toast).textContent = message;
    toast.classList.add("is-visible");
    clearTimeout(showToast.timer);
    showToast.timer = setTimeout(() => toast.classList.remove("is-visible"), 5000);
  }

  async function refreshCartCount() {
    const response = await fetch(`${window.routes?.cart_url || "/cart"}.js`, { headers: { Accept: "application/json" } });
    if (!response.ok) return;
    const cart = await response.json();
    $$('[data-harrys-cart-count]').forEach((badge) => {
      badge.textContent = String(cart.item_count);
      badge.hidden = cart.item_count === 0;
    });
  }

  $$('[data-harrys-quick-add]').forEach((form) => {
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      const button = $("button[type=submit]", form);
      if (!button || button.disabled) return;
      button.disabled = true;
      const original = button.textContent;
      button.textContent = "Adding…";
      try {
        const response = await fetch(window.routes?.cart_add_url || "/cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: new FormData(form),
        });
        if (!response.ok) throw new Error("Unable to add this item.");
        await refreshCartCount();
        showToast("Added to your cart.");
        const drawer = $("cart-drawer");
        if (drawer && typeof drawer.open === "function") {
          const item = await response.json().catch(() => null);
          drawer.open(button, item?.key);
        }
      } catch (error) {
        showToast(error instanceof Error ? error.message : "Unable to add this item.");
      } finally {
        button.disabled = false;
        button.textContent = original;
      }
    });
  });

  $$('[data-harrys-cart-link]').forEach((link) => {
    link.addEventListener("click", (event) => {
      const drawer = $("cart-drawer");
      if (!drawer || typeof drawer.open !== "function") return;
      event.preventDefault();
      drawer.open(link);
    });
  });

  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.matches("[data-harrys-quick-add]")) return;
    const action = form.getAttribute("action") || "";
    if (!/\/cart\/add(?:\.js)?(?:\?|$)/.test(action)) return;
    [900, 2200, 4200].forEach((delay) => {
      setTimeout(() => refreshCartCount().catch(() => {}), delay);
    });
  }, true);

  const nativeCartDrawer = $("cart-drawer");
  if (nativeCartDrawer && typeof MutationObserver !== "undefined") {
    let badgeRefreshTimer;
    new MutationObserver(() => {
      clearTimeout(badgeRefreshTimer);
      badgeRefreshTimer = setTimeout(() => refreshCartCount().catch(() => {}), 250);
    }).observe(nativeCartDrawer, { childList: true, subtree: true });
  }

  if (window.HarrysThemeAssets) {
    $$('[data-harrys-asset]').forEach((image) => {
      const url = window.HarrysThemeAssets[image.dataset.harrysAsset];
      if (url && !image.getAttribute("src")) image.src = url;
    });
  }

  refreshCartCount().catch(() => {});
})();
